import { AfterViewChecked, Directive, ElementRef, inject } from '@angular/core'
import { AbstractControl, NgControl, Validators } from '@angular/forms'
import { SeFeFormService } from 'se-fe-form-service'

@Directive({
  selector: '[sePoAriaValidity]',
  standalone: true,
})
export class AriaValidityDirective implements AfterViewChecked {
  private readonly elementRef = inject(ElementRef)
  private readonly formService = inject(SeFeFormService)
  private readonly ngControl = inject(NgControl, { self: true, optional: true })

  public ngAfterViewChecked(): void {
    const input = this.input
    if (!input) return

    this.setFlag(input, 'aria-required', this.isRequired)
    this.setFlag(input, 'aria-invalid', this.isShowingError)
  }

  private get control(): AbstractControl | null {
    return this.ngControl?.control ?? null
  }

  private get input(): HTMLElement {
    return this.elementRef.nativeElement.querySelector('input, select, textarea')
  }

  private get isRequired(): boolean {
    return !!this.control?.hasValidator(Validators.required)
  }

  private get isShowingError(): boolean {
    if (!this.ngControl) return false
    const hasParent = !!(this.ngControl as any)._parent
    const submitted = hasParent ? undefined : false
    return this.formService.controlErrors(this.ngControl, submitted).length > 0
  }

  private setFlag(input: HTMLElement, attribute: string, on: boolean): void {
    if (on) input.setAttribute(attribute, 'true')
    else input.removeAttribute(attribute)
  }
}
